import { render, staticRenderFns } from "./ChoiceItems.vue?vue&type=template&id=7dc68b92&scoped=true"
import script from "./ChoiceItems.vue?vue&type=script&lang=js"
export * from "./ChoiceItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc68b92",
  null
  
)

export default component.exports